import isEmpty from 'lodash-es/isEmpty'

export function getIsViewingDocumentsEmpty({ documents, isInitiated }) {
  return isInitiated && isEmpty(documents)
}
